import { createSelector } from 'reselect'

/** A Redux selector to retrieve URL Params
 * @param state - The Redux state
 * @param {String} - The URL Params to fetch
 */

const getSubscribers = (state: any) => state.subscribers ? state.subscribers : undefined

/** A Redux selector to retrieve Latest Subscribers
 * @param state - The Redux state
 * @param {Array} - Fetching Latest Subscribers
 */

export const selectSubscribers = createSelector(
  getSubscribers,
  (data) => data ? data.subscribers : null
)

/** A Redux selector to retrieve Latest Subscribers Is Loading state
 * @param state - The Redux state
 * @param {Boolean} - Fetching Latest Subscribers Is Loading
 */

export const selectSubscribersIsLoading = createSelector(
  getSubscribers,
  (data) => data && data.status ? data.status.isLoading : null
)

/** A Redux selector to retrieve Total Subscribers
 * @param state - The Redux state
 * @param {Boolean} - Fetching Toal Subscribers
 */

export const selectTotalSubscribers = createSelector(
  getSubscribers,
  (data) => data ? data.total : 0
)
